import React from "react";
import { Compass, UserCheck, Zap, MapPin } from "lucide-react";

const ITEMS = [
  {
    icon: Compass,
    title: "Independent brokerage",
    desc: "We work for you — not the carriers. More options, better rates, no loyalty tax.",
  },
  {
    icon: UserCheck,
    title: "Personalized strategy",
    desc: "Coverage built around your life, assets, and risk — not a pre-made template.",
  },
  {
    icon: Zap,
    title: "Fast service, real advisors",
    desc: "Direct access to licensed humans. No phone trees. No ticket queues.",
  },
  {
    icon: MapPin,
    title: "Serving California",
    desc: "Deep local expertise across CA markets, regulations, and carrier relationships.",
  },
];

export default function WhySwia() {
  return (
    <section
      id="why"
      data-testid="section-why"
      className="bg-white border-t border-neutral-200"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-36">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-4" data-reveal>
            <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-6">
              Why SWIA
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold tracking-[-0.03em] text-black leading-[1.02]">
              Advisors, not
              <br />
              <span className="italic font-medium">sales reps.</span>
            </h2>
            <p className="mt-6 max-w-md text-neutral-600 leading-relaxed">
              SWIA was built for a higher standard of insurance — precise,
              transparent, and relentlessly on your side.
            </p>
          </div>

          <div
            className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-0 divide-y md:divide-y-0 md:divide-x divide-neutral-200 border-y border-neutral-200 md:border-y-0"
            data-reveal-group
          >
            {ITEMS.map(({ icon: Icon, title, desc }, i) => (
              <div
                key={title}
                data-testid={`why-item-${i + 1}`}
                data-reveal-child
                data-reveal-delay={i + 1}
                className={`p-8 md:p-10 ${
                  i < 2 ? "md:border-b md:border-neutral-200" : ""
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className="mt-1 w-10 h-10 shrink-0 border border-neutral-300 rounded-full flex items-center justify-center">
                    <Icon size={16} strokeWidth={1.6} />
                  </div>
                  <div>
                    <div className="flex items-center gap-3">
                      <span className="font-display text-sm text-neutral-400">
                        0{i + 1}
                      </span>
                      <h3 className="font-display text-xl md:text-2xl font-semibold text-black tracking-[-0.01em]">
                        {title}
                      </h3>
                    </div>
                    <p className="mt-3 text-neutral-600 leading-relaxed text-[15px]">
                      {desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
